import { ReactElement, useEffect, useState } from 'react';
import RawDataOverviewContainer from './OverviewContainer';
import DropdownCustom from '../../controls/DropdownCustom';
import Contor from '../contor';
import { useData } from '../../context/data.context';
import { Group, ParametersType } from '../../constants/telosair-interfaces';

type ContourProps = {
  onBackPress?: () => void;
};

/**
 * React component for contour.
 * @param props - Properties of Contour component.
 * @returns - React component for contour.
 */
export default function ZoomedHeatMap(props: ContourProps): ReactElement {
  const { onBackPress } = props;
  const [selectedParameter, setSelectedParameter] = useState('');
  const [selectedGroup, setSelectedGroup] = useState<Group | null>(null);
  const { groupedData, loading, parameters } = useData();

  useEffect(() => {
    if (!loading && groupedData.length > 0) {
      setSelectedGroup(groupedData[0]);
    }
  }, [groupedData]);

  /**
   * Handles changes in dropdown input values to select parameter.
   * @param selectedValue - The selected value of the parameter input change.
   */
  const handleOptionsSelectTemperature = (selectedValue: ParametersType): void => {
    setSelectedParameter(selectedValue);
  };

  return (
    <RawDataOverviewContainer
      loading={loading}
      onBackPress={onBackPress}
      zoomed
      sectionName="Heatmaps"
      size="full"
    >
      <div className="max-w-9/12 w-9/12 overflow-auto">
        <div className="items-center hidden">
          <div className="font-medium text-gray-300">{selectedGroup?.groupName}</div>
          <DropdownCustom<ParametersType>
            onClick={handleOptionsSelectTemperature}
            controlPlaceholder={selectedParameter.length > 0 ? selectedParameter : 'Parameter'}
            buttons={parameters.map((item) => ({ name: item.shortName, id: item.parameterName }))}
          />
        </div>
        <div className="h-full">
          {selectedGroup && <Contor selectedParameters={[]} group={selectedGroup} />}
        </div>
      </div>
      <div className="w-[20%]">
        {groupedData.map((item) => {
          return (
            <button
              type="button"
              onClick={() => setSelectedGroup(item)}
              className={`${
                selectedGroup?.groupId === item.groupId ? 'border border-primary-600' : ''
              } rounded p-3 dark:bg-background-700 bg-white mb-2 w-full`}
              key={item.groupId}
            >
              <div className="h-[9.125rem] w-full">
                <Contor selectedParameters={[]} group={item} />
              </div>
              <div className="text-xs text-center dark:text-white text-gray-900 mt-2">
                {item.groupName}
              </div>
            </button>
          );
        })}
      </div>
    </RawDataOverviewContainer>
  );
}
